import { MIME_TYPES } from '@mantine/dropzone';

const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	HEADER_HEIGHT: 70,
	TABLE_PAGE_SIZES: [15, 50, 100],
	DEFAULT_LANGUAGE: 'PL',
	ADMIN_DEFAULT_ROLE_ID: crypto.randomUUID(),
	DESCRIPTION_MAX_LENGTH: 1000,
	SESSION_STORAGE_KEYS: {
		REFRESH_TOKEN: 'refreshToken',
		CONTENT: {
			PAGE: 'content-page',
			LIMIT: 'content-limit',
			SEARCH: 'content-search',
			SORT: 'content-sort',
		},
		ACCESSORY: {
			CATEGORY_ID: 'category-id',
		},
	},

	MATERIAL_EXTENSIONS: [MIME_TYPES.png, MIME_TYPES.jpeg],
	MATERIAL_FILE_TYPES: ['.glb'],
	MODEL_FILE_TYPES: ['.glb'],
	MAX_TEXTURE_SIZE_IN_MB: 1,
	MAX_MODEL_SIZE_IN_MB: 5,
	ISO_639: [
		'ad',
		'al',
		'am',
		'at',
		'az',
		'ba',
		'be',
		'bg',
		'by',
		'ch',
		'cy',
		'cz',
		'de',
		'dk',
		'ee',
		'es',
		'fi',
		'fr',
		'gb',
		'ge',
		'gr',
		'hr',
		'hu',
		'ie',
		'is',
		'it',
		'kz',
		'li',
		'lt',
		'lu',
		'lv',
		'mc',
		'md',
		'me',
		'mk',
		'mt',
		'nl',
		'no',
		'pl',
		'pt',
		'ro',
		'rs',
		'ru',
		'se',
		'si',
		'sk',
		'sm',
		'tr',
		'ua',
		'us',
		'nz',
	],
	ACCESSORY_COLLISION_LAYERS: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
} as const;

export default APP_CONFIG;
